import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const BASIN_HIE: any = ['COUNTRY', 'BASINV2', 'SUBBASINV2']
export const RAINFALL_FORECAST_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        [AgricultureMapConstants.VIEWS.ADMIN]: {
            'State Boundary': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'RAINFALL_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State Boundaries',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District Boundaries',
                name: 'District Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
                layer_name: 'District Boundary',
                layeroptions_pane: 'district',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'RAINFALL_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'Block Boundary': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
                layer_name: 'Block Boundary',
                layeroptions_pane: 'state',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'RAINFALL_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundary Labels': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
                layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
                crs: 'EPSG4326',
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED',
                crs: 'EPSG4326',
            },
            'Block Boundary Labels': {
                source: 'INDIA',
                displayName: 'Block Boundary Labels',
                name: 'Block Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
                layer_name: 'Block Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'dist_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED',
                crs: 'EPSG4326',
            },
        },
        [AgricultureMapConstants.VIEWS.BASIN]: {
            'State Boundary': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BASIN',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'RAINFALL_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State Boundaries',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BASIN',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District Boundaries',
                name: 'District Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_SUBBASIN',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_SUBBASIN',
                layer_name: 'District Boundary',
                layeroptions_pane: 'district',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'RAINFALL_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            // 'Block Boundary': {
            //     source: 'INDIA',
            //     displayName: 'Block',
            //     name: 'Block Boundary',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.BASIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            //     layer_name: 'Block Boundary',
            //     layeroptions_pane: 'state',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            //     group: 'boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            //     type: LAYER_TYPES.VECTOR_LAYER,
            //     cql_filter_value: null,
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     crs: 'EPSG4326',
            //     hasLables: true,
            //     applycql_filter: true,
            //     legendName: 'RAINFALL_LEGEND',
            //     layeroptions_protocol: 'WFS'
            // },
            'State Boundary Labels': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BASIN',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BASIN_NAMES',
                crs: 'EPSG4326',
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.BASIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_SUBBASIN',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'state_uuid',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_SUBBASIN_NAMES',
                crs: 'EPSG4326',
            },
            // 'Block Boundary Labels': {
            //     source: 'INDIA',
            //     displayName: 'Block Boundary Labels',
            //     name: 'Block Boundary Labels',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.BASIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            //     layer_name: 'Block Boundary Labels',
            //     layeroptions_pane: 'depth',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            //     group: 'Labels',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.WMS_LAYER,
            //     type: LAYER_TYPES.WMS_LAYER,
            //     cql_filter_value: 'dist_uuid',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED',
            //     crs: 'EPSG4326',
            // },
        },
    }
}
export const RAINFALL_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        RAINFALL_LEGEND: {
            // "Units": "Heatwave ",
            "colorValues": [
                {
                    backgroundColor: '#fff',
                    text: '<span class="rf-lbl" data-rf="No Rain">0.0 - 0.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#c3fdca',
                    text: '<span class="rf-lbl" data-rf="Very Light">0.1 - 1.7</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#00fe08',
                    text: '<span class="rf-lbl" data-rf="Light">1.7 - 7.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#038500',
                    text: '<span class="rf-lbl" data-rf="Moderate">7.1 - 28.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fdbfc9',
                    text: '<span class="rf-lbl" data-rf="Heavy">28.1 - 52.3</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fc0300',
                    text: '<span class="rf-lbl" data-rf="Very Heavy">52.3 - 87.8</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#610301',
                    text: '<span class="rf-lbl" data-rf="Extreme">87.8 - 168.9</span>',
                    textColor: '#fff'
                },
                {
                    backgroundColor: '#9932cc',
                    text: '<span class="rf-lbl" data-rf="Cloud Burst">>168.9</span>',
                    textColor: '#ffffff'
                },
                // {
                //     backgroundColor: '#e6eeff',
                //     text: '0.5-2.5',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#80aaff',
                //     text: '2.5-5',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#3377ff',
                //     text: '5-10',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#003cb3',
                //     text: '10-20',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#002266',
                //     text: '20-30',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#ff80b3',
                //     text: '30-40',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#ff0066',
                //     text: '40-50',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#cc0000',
                //     text: '50-75',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#660000',
                //     text: '75-100',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#ffcccc',
                //     text: '100-1000',
                //     textColor: '#000000'
                // }
            ]
        },

        'RAINFALL_LEGEND_GOOGLE_WEATHER': {
            "colorValues": [
                {
                    backgroundColor: '#fff',
                    text: '<span class="rf-lbl" data-rf="No Rain">0.0 - 0.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#c3fdca',
                    text: '<span class="rf-lbl" data-rf="Very Light">0.1 - 2.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#00fe08',
                    text: '<span class="rf-lbl" data-rf="Light">2.1 - 9.0</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#038500',
                    text: '<span class="rf-lbl" data-rf="Moderate">9.0 - 36.1</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fdbfc9',
                    text: '<span class="rf-lbl" data-rf="Heavy">36.1 - 66.8</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fc0300',
                    text: '<span class="rf-lbl" data-rf="Very Heavy">66.8 - 113.4</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#610301',
                    text: '<span class="rf-lbl" data-rf="Extreme">113.4 - 286.4</span>',
                    textColor: '#fff'
                },
                {
                    backgroundColor: '#9932cc',
                    text: '<span class="rf-lbl" data-rf="Cloud Burst">>= 286.4</span>',
                    textColor: '#ffffff'
                },
            ]
        },
        '7DAYS_RAINFALL_LEGEND': {
            "colorValues": [
                {
                    backgroundColor: '#fff',
                    text: '<span class="rf-lbl" data-rf="No Rain">0.0 - 0.3</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#c3fdca',
                    text: '<span class="rf-lbl" data-rf="Very Light">0.3 - 2.5</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#00fe08',
                    text: '<span class="rf-lbl" data-rf="Light">2.5 - 15.6</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#038500',
                    text: '<span class="rf-lbl" data-rf="Moderate">15.6 - 64.5</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fdbfc9',
                    text: '<span class="rf-lbl" data-rf="Heavy">64.5 - 115.6</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#fc0300',
                    text: '<span class="rf-lbl" data-rf="Very Heavy">115.6 - 204.5</span>',
                    textColor: '#000000'
                },
                {
                    backgroundColor: '#610301',
                    text: '<span class="rf-lbl" data-rf="Extreme">204.5 - 300.1</span>',
                    textColor: '#fff'
                },
                {
                    backgroundColor: '#9932cc',
                    text: '<span class="rf-lbl" data-rf="Cloud Burst">>= 300.1</span>',
                    textColor: '#ffffff'
                },
            ]
        },
        // Rainfall (Deterministic + Extended) — ECMWF_EXT_WEEKLY_SUM weekly-accumulated heatmap legend.
        ECMWF_EXT_WEEKLY_SUM_LEGEND: {
            "colorValues": [
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="0-10">0-10</span>',
                    textColor: '#000000',
                    chartText: '0-10'
                },
                {
                    backgroundColor: '#C9FEE5',
                    text: '<span class="rf-lbl" data-rf="10-30">10-30</span>',
                    textColor: '#000000',
                    chartText: '10-30'
                },
                {
                    backgroundColor: '#45D11F',
                    text: '<span class="rf-lbl" data-rf="30-60">30-60</span>',
                    textColor: '#000000',
                    chartText: '30-60'
                },
                {
                    backgroundColor: '#006400',
                    text: '<span class="rf-lbl" data-rf="60-100">60-100</span>',
                    textColor: '#ffffff',
                    chartText: '60-100'
                },
                {
                    backgroundColor: '#FFDDDD',
                    text: '<span class="rf-lbl" data-rf="100-200">100-200</span>',
                    textColor: '#000000',
                    chartText: '100-200'
                },
                {
                    backgroundColor: '#ff4136',
                    text: '<span class="rf-lbl" data-rf="200-300">200-300</span>',
                    textColor: '#ffffff',
                    chartText: '200-300'
                },
                {
                    backgroundColor: '#761E0B',
                    text: '<span class="rf-lbl" data-rf=">300">&gt;300</span>',
                    textColor: '#ffffff',
                    chartText: '>300'
                }
            ]
        },
        ECMWF_EXT_WEEKLY_MEAN: {
            "colorValues": [
                // {
                //     backgroundColor: '#ffffff',
                //     text: '0-10',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#feec95',
                //     text: '10-20',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#CCFF00',
                //     text: '20-40',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#33FF00',
                //     text: '40-60',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#029934',
                //     text: '60-100',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#00FFFF',
                //     text: '100-140',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#0066FF',
                //     text: '140-180',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#3300FF',
                //     text: '180-240',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#CC00FF',
                //     text: '240-300',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#FF0099',
                //     text: '300-1000',
                //     textColor: '#000000'
                // }
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="0-10">0-10</span>',
                    textColor: '#000000',
                    chartText: '0-10'
                },
                {
                    backgroundColor: '#c3fdca',
                    text: '<span class="rf-lbl" data-rf="10-30">10-30</span>',
                    textColor: '#000000',
                    chartText: '10-30'
                },
                {
                    backgroundColor: '#00fe08',
                    text: '<span class="rf-lbl" data-rf="30-60">30-60</span>',
                    textColor: '#000000',
                    chartText: '30-60'
                },
                {
                    backgroundColor: '#038500',
                    text: '<span class="rf-lbl" data-rf="60-100">60-100</span>',
                    textColor: '#000000',
                    chartText: '60-100'
                },
                {
                    backgroundColor: '#fdbfc9',
                    text: '<span class="rf-lbl" data-rf="100-200">100-200</span>',
                    textColor: '#000000',
                    chartText: '100-200'
                },
                {
                    backgroundColor: '#fc0300',
                    text: '<span class="rf-lbl" data-rf="200-300">200-300</span>',
                    textColor: '#000000',
                    chartText: '200-300'
                },
                {
                    backgroundColor: '#610301',
                    text: '<span class="rf-lbl" data-rf=">300">>300</span>',
                    textColor: '#fff',
                    chartText: '>300'
                },
            ]
        },
        ECMWF_EXT_WEEKLY_ANOMALY: {
            "colorValues": [
                {
                    backgroundColor: '#592D00',
                    text: '<span class="rf-lbl" data-rf="-1000 to -90">-1000 to -90</span>',
                    textColor: '#fff',
                    chartText: '-1000--90'
                },
                {
                    backgroundColor: '#AE5701',
                    text: '<span class="rf-lbl" data-rf="-90 to -60">-90 to -60</span>',
                    textColor: '#000000',
                    chartText: '-90--60'
                },
                {
                    backgroundColor: '#FE7E01',
                    text: '<span class="rf-lbl" data-rf="-60 to -30">-60 to -30</span>',
                    textColor: '#000000',
                    chartText: '-60--30'
                },
                {
                    backgroundColor: '#FFB264',
                    text: '<span class="rf-lbl" data-rf="-30 to -10">-30 to -10</span>',
                    textColor: '#000000',
                    chartText: '-30--10'
                },
                {
                    backgroundColor: '#FED9B3',
                    text: '<span class="rf-lbl" data-rf="-10 to -5">-10 to -5</span>',
                    textColor: '#000000',
                    chartText: '-10--5'
                },
                {
                    backgroundColor: '#FFFFFF',
                    text: '<span class="rf-lbl" data-rf="-5 to 5">-5 to 5</span>',
                    textColor: '#000000',
                    chartText: '-5-5'
                },
                {
                    backgroundColor: '#DBF1A8',
                    text: '<span class="rf-lbl" data-rf="5 to 10">5 to 10</span>',
                    textColor: '#000000',
                    chartText: '5-10'
                },
                {
                    backgroundColor: '#B7E45A',
                    text: '<span class="rf-lbl" data-rf="10 to 30">10 to 30</span>',
                    textColor: '#000000',
                    chartText: '10-30'
                },
                {
                    backgroundColor: '#86CB01',
                    text: '<span class="rf-lbl" data-rf="30 to 60">30 to 60</span>',
                    textColor: '#000000',
                    chartText: '30-60'
                },
                {
                    backgroundColor: '#649801',
                    text: '<span class="rf-lbl" data-rf="60 to 90">60 to 90</span>',
                    textColor: '#000000',
                    chartText: '60-90'
                },
                {
                    backgroundColor: '#507100',
                    text: '<span class="rf-lbl" data-rf="90 to 1000">90 to 1000</span>',
                    textColor: '#fff',
                    chartText: '90-1000'
                }
            ]
        },
        ECMWF_EXT_MONTHLY_MEAN: {
            "colorValues": [
                // {
                //     backgroundColor: '#ffffff',
                //     text: '0-50',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#feec95',
                //     text: '50-100',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#CCFF00',
                //     text: '100-200',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#33FF00',
                //     text: '200-300',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#029934',
                //     text: '300-500',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#00FFFF',
                //     text: '500-700',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#0066FF',
                //     text: '700-900',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#3300FF',
                //     text: '900-1200',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#CC00FF',
                //     text: '1200-1500',
                //     textColor: '#000000'
                // },
                // {
                //     backgroundColor: '#FF0099',
                //     text: '1500-2000',
                //     textColor: '#000000'
                // }
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="0 to 50">0-50</span>',
                    textColor: '#000000',
                    chartText: '0-50'
                },
                {
                    backgroundColor: '#C9FFE5',
                    text: '<span class="rf-lbl" data-rf="50 to 200">50-200</span>',
                    textColor: '#000000',
                    chartText: '50-200'
                },
                {
                    backgroundColor: '#45D11F',
                    text: '<span class="rf-lbl" data-rf="200 to 400">200-400</span>',
                    textColor: '#000000',
                    chartText: '200-400'
                },
                {
                    backgroundColor: '#006400',
                    text: '<span class="rf-lbl" data-rf="400 to 600">400-600</span>',
                    textColor: '#ffffff',
                    chartText: '400-600'
                },
                {
                    backgroundColor: '#FFDDDD',
                    text: '<span class="rf-lbl" data-rf="600 to 800">600-800</span>',
                    textColor: '#000000',
                    chartText: '600-800'
                },
                {
                    backgroundColor: '#ff4136',
                    text: '<span class="rf-lbl" data-rf="800 to 1200">800-1200</span>',
                    textColor: '#000000',
                    chartText: '800-1200'
                },
                {
                    backgroundColor: '#761E0B',
                    text: '<span class="rf-lbl" data-rf=">1200">>1200</span>',
                    textColor: '#fff',
                    chartText: '>1200'
                },
            ]
        },
        ECMWF_EXT_MONTHLY_ANOMALY: {
            "colorValues": [
                {
                    backgroundColor: '#963400',
                    text: '<span class="rf-lbl" data-rf="-350 to -200">-350 to -200</span>',
                    textColor: '#fff',
                    chartText: '-350--200'
                },
                {
                    backgroundColor: '#ca8903',
                    text: '<span class="rf-lbl" data-rf="-200 to -100">-200 to -100</span>',
                    textColor: '#000000',
                    chartText: '-200--100'
                },
                {
                    backgroundColor: '#ffde00',
                    text: '<span class="rf-lbl" data-rf="-100 to -25">-100 to -25</span>',
                    textColor: '#000000',
                    chartText: '-100--25'
                },
                {
                    backgroundColor: '#feec95',
                    text: '<span class="rf-lbl" data-rf="-25 to -10">-25 to -10</span>',
                    textColor: '#000000',
                    chartText: '-25--10'
                },
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="-10 to 0">-10 to 0</span>',
                    textColor: '#000000',
                    chartText: '-10-0'
                },
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="0 to 10">0 to 10</span>',
                    textColor: '#000000',
                    chartText: '0-10'
                },
                {
                    backgroundColor: '#caff63',
                    text: '<span class="rf-lbl" data-rf="10 to 25">10 to 25</span>',
                    textColor: '#000000',
                    chartText: '10-25'
                },
                {
                    backgroundColor: '#24fc06',
                    text: '<span class="rf-lbl" data-rf="25 to 100">25 to 100</span>',
                    textColor: '#000000',
                    chartText: '25-100'
                },
                {
                    backgroundColor: '#029934',
                    text: '<span class="rf-lbl" data-rf="100 to 200">100 to 200</span>',
                    textColor: '#000000',
                    chartText: '100-200'
                },
                {
                    backgroundColor: '#026469',
                    text: '<span class="rf-lbl" data-rf="200 to 350">200 to 350</span>',
                    textColor: '#fff',
                    chartText: '200-350'
                }
            ]
        },
        // ECMWF_EXT_SEASONAL_MEAN: {
        //     "colorValues": [
        //         {
        //             backgroundColor: '#ffffff',
        //             text: '0-200',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#c3fdca',
        //             text: '200-400',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#00fe08',
        //             text: '400-600',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#038500',
        //             text: '600-900',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#fef09b',
        //             text: '900-1200',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#fdbfc9',
        //             text: '1200-1600',
        //             textColor: '#000000'
        //         },
        //         {
        //             backgroundColor: '#fc0300',
        //             text: '>1600',
        //             textColor: '#ffffff'
        //         }
        //     ]
        // },
        // ECMWF_EXT_SEASONAL_ANOMALY: {
        //     "colorValues": [
        //         {
        //             backgroundColor: '#963400',
        //             text: '-350 to -200',
        //             textColor: '#fff',
        //             chartText: '-350--200'
        //         },
        //         {
        //             backgroundColor: '#ca8903',
        //             text: '-200 to -100',
        //             textColor: '#000000',
        //             chartText: '-200--100'
        //         },
        //         {
        //             backgroundColor: '#ffde00',
        //             text: '-100 to -25',
        //             textColor: '#000000',
        //             chartText: '-100--25'
        //         },
        //         {
        //             backgroundColor: '#feec95',
        //             text: '-25 to -10',
        //             textColor: '#000000',
        //             chartText: '-25--10'
        //         },
        //         {
        //             backgroundColor: '#ffffff',
        //             text: '-10 to 0',
        //             textColor: '#000000',
        //             chartText: '-10-0'
        //         },
        //         {
        //             backgroundColor: '#ffffff',
        //             text: '0 to 10',
        //             textColor: '#000000',
        //             chartText: '0-10'
        //         },
        //         {
        //             backgroundColor: '#caff63',
        //             text: '10 to 25',
        //             textColor: '#000000',
        //             chartText: '10-25'
        //         },
        //         {
        //             backgroundColor: '#24fc06',
        //             text: '25 to 100',
        //             textColor: '#000000',
        //             chartText: '25-100'
        //         },
        //         {
        //             backgroundColor: '#029934',
        //             text: '100 to 200',
        //             textColor: '#000000',
        //             chartText: '100-200'
        //         },
        //         {
        //             backgroundColor: '#026469',
        //             text: '200 to 350',
        //             textColor: '#fff',
        //             chartText: '200-350'
        //         }

        ECMWF_EXT_SEASONAL_MEAN: {
            colorValues: [
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="0 to 100">0-100</span>',
                    textColor: '#000000',
                    chartText: '0-100'
                },
                {
                    backgroundColor: '#C9FFE5',
                    text: '<span class="rf-lbl" data-rf="100 to 500">100-500</span>',
                    textColor: '#000000',
                    chartText: '100-500'
                },
                {
                    backgroundColor: '#45D11F',
                    text: '<span class="rf-lbl" data-rf="500 to 1000">500-1000</span>',
                    textColor: '#000000',
                    chartText: '500-1000'
                },
                {
                    backgroundColor: '#006400',
                    text: '<span class="rf-lbl" data-rf="1000 to 1500">1000-1500</span>',
                    textColor: '#ffffff',
                    chartText: '1000-1500'
                },
                {
                    backgroundColor: '#FFDDDD',
                    text: '<span class="rf-lbl" data-rf="1500 to 2000">1500-2000</span>',
                    textColor: '#000000',
                    chartText: '1500-2000'
                },
                {
                    backgroundColor: '#ff4136',
                    text: '<span class="rf-lbl" data-rf="2000 to 3000">2000-3000</span>',
                    textColor: '#ffffff',
                    chartText: '2000-3000'
                },
                {
                    backgroundColor: '#761E0B',
                    text: '<span class="rf-lbl" data-rf=">3000">>3000</span>',
                    textColor: '#ffffff',
                    chartText: '>3000'
                }
            ]
        },
        ECMWF_EXT_SEASONAL_ANOMALY: {
            colorValues: [
                {
                    backgroundColor: '#963400',
                    text: '<span class="rf-lbl" data-rf="< -250"> < -250</span>',
                    textColor: '#fff',
                    chartText: '<-250'
                },
                {
                    backgroundColor: '#ca8903',
                    text: '<span class="rf-lbl" data-rf="-250 to -100">-250 to -100</span>',
                    textColor: '#000000',
                    chartText: '-250--100'
                },
                {
                    backgroundColor: '#ffde00',
                    text: '<span class="rf-lbl" data-rf="-100 to -50">-100 to -50</span>',
                    textColor: '#000000',
                    chartText: '-100--50'
                },
                {
                    backgroundColor: '#feec95',
                    text: '<span class="rf-lbl" data-rf="-50 to -20">-50 to -20</span>',
                    textColor: '#000000',
                    chartText: '-50--20'
                },
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="-20 to 20">-20 to 20</span>',
                    textColor: '#000000',
                    chartText: '-20-20'
                },
                {
                    backgroundColor: '#caff63',
                    text: '<span class="rf-lbl" data-rf="20 to 50">20 to 50</span>',
                    textColor: '#000000',
                    chartText: '20-50'
                },
                {
                    backgroundColor: '#24fc06',
                    text: '<span class="rf-lbl" data-rf="50 to 100">50 to 100</span>',
                    textColor: '#000000',
                    chartText: '50-100'
                },
                {
                    backgroundColor: '#029934',
                    text: '<span class="rf-lbl" data-rf="100 to 250">100 to 250</span>',
                    textColor: '#000000',
                    chartText: '100-250'
                },
                {
                    backgroundColor: '#026469',
                    text: '<span class="rf-lbl" data-rf=">250">>250</span>',
                    textColor: '#fff',
                    chartText: '>250'
                }
            ]
        },
        ECMWF_EXT_MONSOON_ANOMALY_PER: {
            colorValues: [
                {
                    backgroundColor: '#963400',
                    text: '<span class="rf-lbl" data-rf=" ≤ -60%"> ≤ -60%</span>',
                    textColor: '#fff',
                    chartText: ' ≤ -60%'
                },
                {
                    backgroundColor: '#ca8903',
                    text: '<span class="rf-lbl" data-rf="-59% to -20%">-59% to -20%</span>',
                    textColor: '#000000',
                    chartText: '-59% - -20%'
                },
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="-19% to +19%">-19% to +19%</span>',
                    textColor: '#000000',
                    chartText: '-19% - +19%'
                },
                {
                    backgroundColor: '#029934',
                    text: '<span class="rf-lbl" data-rf="+20% to +60%">+20% to +60%</span>',
                    textColor: '#000000',
                    chartText: '+20% - +60%'
                },
                {
                    backgroundColor: '#026469',
                    text: '<span class="rf-lbl" data-rf=" >= +60%"> >= +60%</span>',
                    textColor: '#000000',
                    chartText: ' >= +60%'
                }
            ]
        },
        // ECMWF_EXT_MONSOON_ANOMALY_PER: {
        //     colorValues: [
        //         {
        //             backgroundColor: '#963400',
        //             text: '-1000% to -50%',
        //             textColor: '#fff',
        //             chartText: '-1000%--50%'
        //         },
        //         {
        //             backgroundColor: '#ca8903',
        //             text: '-50% to -30%',
        //             textColor: '#000000',
        //             chartText: '-50%--30%'
        //         },
        //         {
        //             backgroundColor: '#ffde00',
        //             text: '-30% to -20%',
        //             textColor: '#000000',
        //             chartText: '-30%--20%'
        //         },
        //         {
        //             backgroundColor: '#feec95',
        //             text: '-20% to -10%',
        //             textColor: '#000000',
        //             chartText: '-20%--10%'
        //         },
        //         {
        //             backgroundColor: '#ffffff',
        //             text: '-10% to 0%',
        //             textColor: '#000000',
        //             chartText: '-10%-0%'
        //         },
        //         {
        //             backgroundColor: '#ffffff',
        //             text: '0% to 10%',
        //             textColor: '#000000',
        //             chartText: '0%-10%'
        //         },
        //         {
        //             backgroundColor: '#caff63',
        //             text: '10% to 20%',
        //             textColor: '#000000',
        //             chartText: '10%-20%'
        //         },
        //         {
        //             backgroundColor: '#24fc06',
        //             text: '20% to 30%',
        //             textColor: '#000000',
        //             chartText: '20%-30%'
        //         },
        //         {
        //             backgroundColor: '#029934',
        //             text: '30% to 50%',
        //             textColor: '#000000',
        //             chartText: '30%-50%'
        //         },
        //         {
        //             backgroundColor: '#026469',
        //             text: '50% to 1000%',
        //             textColor: '#fff',
        //             chartText: '50%-1000%'
        //         }
        //     ]
        // },
        ECMWF_EXT_MONTHLY_ANOMALY_PER: {
            colorValues: [
                {
                    backgroundColor: '#963400',
                    text: '<span class="rf-lbl" data-rf="≤ -60%">≤ -60%</span>',
                    textColor: '#fff',
                    chartText: '≤ -60%'
                },
                {
                    backgroundColor: '#ca8903',
                    text: '<span class="rf-lbl" data-rf="-59% to -20%">-59% to -20%</span>',
                    textColor: '#000000',
                    chartText: '-59% to -20%'
                },
                {
                    backgroundColor: '#ffffff',
                    text: '<span class="rf-lbl" data-rf="-19% to +19%">-19% to +19%</span>',
                    textColor: '#000000',
                    chartText: '-19% to +19%'
                },
                {
                    backgroundColor: '#029934',
                    text: '<span class="rf-lbl" data-rf="+20% to +60%">+20% to +60%</span>',
                    textColor: '#000000',
                    chartText: '+20% to +60%'
                },
                {
                    backgroundColor: '#026469',
                    text: '<span class="rf-lbl" data-rf="≥ +60%">≥ +60%</span>',
                    textColor: '#000000',
                    chartText: '≥ +60%'
                }
            ]
        },
        YTD_DEVIATION_LEGEND: {
            "colorValues": [
                {
                    backgroundColor: '#C1C1C1',
                    text: 'No Data <br> &nbsp;',
                    textColor: '#000000',
                },
                {
                    backgroundColor: '#FEFFFF',
                    text: '-100% <br> (No Rain)',
                    textColor: '#000000',
                },
                {
                    backgroundColor: '#FCFD13',
                    text: '-99% to -60% <br> (Large Deficient)',
                    textColor: '#000000',
                },
                {
                    backgroundColor: '#F14518',
                    text: '-59% to -20% <br> (Deficient)',
                    textColor: '#ffffff',
                },
                {
                    backgroundColor: '#79C66D',
                    text: '-19% to 19% <br> (Normal)',
                    textColor: '#000000',
                },
                {
                    backgroundColor: '#70BBF1',
                    text: '20% to 59% <br> (Excess)',
                    textColor: '#000000',
                },
                {
                    backgroundColor: '#149AFF',
                    text: '≥ 60% <br> (Large Excess)',
                    textColor: '#ffffff',
                }
            ]
        },
    }
}

export const RainfallForecastMapConstants: any = {
    PrimarySourceType: 'IMD_SHORT_RANGE',
    SecondarySourceType: 'IMD_LONG_RANGE',

    HeatMapUrl: 'weatherForecast/getHeatMapData/',

    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    },
}
export const ECMWF_SOURCE_TYPES: any = {
    weekly_mean: 'ECMWF_EXT_WEEKLY_MEAN',
    weekly_anomaly: 'ECMWF_EXT_WEEKLY_ANOMALY',
    monthly_mean: 'ECMWF_EXT_MONTHLY_MEAN',
    monthly_anomaly: 'ECMWF_EXT_MONTHLY_ANOMALY',
    seasonal_mean: 'ECMWF_EXT_MONTHLY_MEAN',
    seasonal_anomaly: 'ECMWF_EXT_MONTHLY_ANOMALY',
    seasonal_anomaly_per2: 'ECMWF_EXT_MONTHLY_ANOMALY_PER',
    monthly_anomaly_per: 'ECMWF_EXT_MONTHLY_ANOMALY_PER',
    seasonal_anomaly_per: 'ECMWF_EXT_MONSOON_ANOMALY_PER'
}

export const ECMWF_SEASONAL_COMPONENT_TYPES: any = {
    mean: 'ECMWF_EXT_SEASONAL_MEAN',
    anomaly: 'ECMWF_EXT_SEASONAL_ANOMALY'
}

export const GOOGLE_SOURCE_TYPES: any = {
    '24': 'WEATHER_NEXT_GRAPH',
    '7': 'WEATHER_NEXT_GRAPH'
}

// Daily Trend chart ('+7M' / forecastLength === 'monthly') — year side-panel grouping
export const EL_NINO_YEARS: number[] = [1997, 2002, 2004, 2015, 2018, 2023];
export const LA_NINA_YEARS: number[] = [1999, 2007, 2010, 2011, 2016, 2017, 2020, 2021, 2022, 2024, 2025];
const EL_NINO_PALETTE: string[] = ['#C05A3B', '#D97757', '#E2895E', '#A83F28', '#CB6B4A', '#8F3521'];
const LA_NINA_PALETTE: string[] = ['#0E6E7A', '#1F8A6F', '#128C79', '#2AA37E', '#0B5D63', '#3BAA8C', '#16A085', '#0A4F55', '#4FBFA0', '#2E9C8F', '#63C2A6'];
export const LIVE_YEAR_COLOR = '#3B4956';
export const EL_NINO_DOT_COLOR = '#C05A3B';
export const LA_NINA_DOT_COLOR = '#1F8A6F';

export function getTrendYearColor(year: number, currentYear: number): string {
    if (year === currentYear) { return LIVE_YEAR_COLOR; }
    const elIdx = EL_NINO_YEARS.indexOf(year);
    if (elIdx > -1) { return EL_NINO_PALETTE[elIdx % EL_NINO_PALETTE.length]; }
    const laIdx = LA_NINA_YEARS.indexOf(year);
    if (laIdx > -1) { return LA_NINA_PALETTE[laIdx % LA_NINA_PALETTE.length]; }
    return '#9aa2a7ff';
}